import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { WorkorderAfterSales2ModalComponent } from '../workorder-after-sales2-modal/workorder-after-sales2-modal.component';
@Component({
  selector: 'app-workorder-after-sales1-modal',
  templateUrl: './workorder-after-sales1-modal.component.html',
  styleUrls: ['./workorder-after-sales1-modal.component.scss'],
})
export class WorkorderAfterSales1ModalComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<WorkorderAfterSales1ModalComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private api: UserApiService
  ) {}

  ngOnInit(): void {
    this.findWorkProblems();
  }

  close() {
    this.dialogRef.close();
  }

  openProblemDetail(data: any) {
    this.close();
    this.dialog.open(WorkorderAfterSales2ModalComponent, {
      data: Object.assign({}, data, {
        bus_id: this.data.bus.id,
        bus_seat_id: this.data.id,
        platform_id: this.data.bus.platform_id,
        bus_account_id: this.data.bus.bus_account_id,
        order_id: '',
        platform_name: this.data.platform_name,
      }),
    });
  }

  loading = false;
  problems: any;
  async findWorkProblems() {
    try {
      this.loading = true;
      const r = await this.api.findWorkProblems(
        this.data.platform_name,
        'InUse',
        'zh-CN',
        1,
        50
      );
      this.problems = r.data.list;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
